var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'el-input el-input--'+_vm.size},[_c('money',_vm._b({staticClass:"el-input__inner",on:{"input":_vm.dispatch},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'money',_vm.money,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }